import React, { useState, useEffect } from "react";
import "./BoardRace.css";
import correctSound from "./sounds/correct.mp3";
import wrongSound from "./sounds/wrong.wav";
import winSound from "./sounds/win.mp3";
import diceSound from "./sounds/dice.mp3";

const boards = [
  Array(10).fill("⬜"),
  Array(15).fill("⬜"),
  Array(20).fill("⬜")
];

const emojiOptions = ["😀", "🐱", "🐶", "🚗", "🚀", "🦄", "🐸", "🍕"];

const EmojiBoardRace = () => {
  const [boardIndex, setBoardIndex] = useState(0);
  const [positions, setPositions] = useState([0, 0]);
  const [dice, setDice] = useState(null);
  const [diceTrigger, setDiceTrigger] = useState(false);
  const [turn, setTurn] = useState(0);
  const [players, setPlayers] = useState(["😀", "🐱"]);
  const [scores, setScores] = useState([0, 0]);

  const playSound = (file) => new Audio(file).play();

  const rollDice = () => {
    playSound(diceSound); // 🎲 dice roll sound
    setDiceTrigger(true);
    const roll = Math.floor(Math.random() * 6) + 1;
    setDice(roll);
    const newPos = positions[turn] + roll;
    const newPositions = [...positions];

    if (newPos < boards[boardIndex].length - 1) {
      newPositions[turn] = newPos;
      setPositions(newPositions);
      playSound(correctSound);
      setTurn((turn + 1) % 2);
    } else if (newPos === boards[boardIndex].length - 1) {
      newPositions[turn] = newPos;
      setPositions(newPositions);
      playSound(winSound);
      const newScores = [...scores];
      newScores[turn] += 1;
      setScores(newScores);
      setTimeout(() => alert(`🎉 Player ${turn + 1} (${players[turn]}) wins!`), 500);
      resetGame();
    } else {
      playSound(wrongSound);
      setTurn((turn + 1) % 2);
    }
  };

  const resetGame = () => {
    setPositions([0, 0]);
    setDice(null);
    setTurn(0);
  };

  return (
    <div className="board-race">
      <h2>Emoji Board Race (Multiplayer)</h2>
      <div className="board">
        {boards[boardIndex].map((cell, idx) => (
          <span
            key={idx}
            className={`cell ${
              idx === boards[boardIndex].length - 1 ? "finish" : ""
            }`}
          >
            {positions[0] === idx ? players[0] :
             positions[1] === idx ? players[1] :
             idx === boards[boardIndex].length - 1 ? "🏁" : cell}
          </span>
        ))}
      </div>
      <div className="controls">
        <button onClick={rollDice}>🎲 Roll Dice (Player {turn + 1})</button>
        <button onClick={resetGame}>🔄 Reset</button>
        <DiceCube value={dice} trigger={diceTrigger} />
        <div className="board-selector">
          {boards.map((_, idx) => (
            <button
              key={idx}
              className={boardIndex === idx ? "active" : ""}
              onClick={() => {
                setBoardIndex(idx);
                resetGame();
              }}
            >
              Board {idx + 1} ({boards[idx].length} cells)
            </button>
          ))}
        </div>
        <div className="emoji-selector">
          <p>Select Emojis:</p>
          {emojiOptions.map((emoji, idx) => (
            <button
              key={idx}
              onClick={() => {
                const newPlayers = [...players];
                newPlayers[turn] = emoji;
                setPlayers(newPlayers);
              }}
            >
              {emoji}
            </button>
          ))}
        </div>
      </div>
      <div className="scoreboard">
        <h3>🏆 Scoreboard</h3>
        <p>Player 1 {players[0]}: {scores[0]} wins</p>
        <p>Player 2 {players[1]}: {scores[1]} wins</p>
      </div>
    </div>
  );
};

// DiceCube Component
const DiceCube = ({ value, trigger }) => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (trigger) {
      setAnimate(true);
      setTimeout(() => setAnimate(false), 1200);
    }
  }, [trigger]);

  return (
    <div className={`dice-cube ${animate ? "rolling" : ""}`}>
      <div className="face one">1️⃣</div>
      <div className="face two">2️⃣</div>
      <div className="face three">3️⃣</div>
      <div className="face four">4️⃣</div>
      <div className="face five">5️⃣</div>
      <div className="face six">6️⃣</div>
      {!animate && <div className="result">{value ?? "🎲"}</div>}
    </div>
  );
};

export default EmojiBoardRace;